import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
/* import scrollSpeed from "./plugins/scrollSpeed"; */
import { loadFonts } from "./plugins/webfontloader";
import { createMetaManager, plugin as metaPlugin } from "vue-meta";

loadFonts();

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  /* .use(scrollSpeed) */
  .use(createMetaManager())
  .use(metaPlugin)
  .mount("#app");
